import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['station', 'keyword']
  static values = { rootPath: String, prefPath: String }

  search(event) {
    if (!this.#isStationInputted) {
      this.element.action = this.rootPathValue
      return
    }

    if (this.#isLocalPage) {
      this.element.action = this.prefPathValue
    } else {
      this.dispatch('invalid-station')
      event.preventDefault()
    }
  }

  preventDismiss(event) {
    event.stopPropagation()
  }

  setStationLink({ target }) {
    const url = new URL(target.href)

    if (this.#isKeywordInputted) {
      url.searchParams.set('q', this.#keywordInput)
      url.searchParams.sort()
    }

    target.setAttribute('href', url.href)
  }

  setKeywordLink({ target }) {
    const url = new URL(target.href)

    if (this.#isLocalPage && this.#isStationInputted) {
      url.pathname = this.prefPathValue
      url.searchParams.set('station', this.#stationInput)
      url.searchParams.sort()
    }

    target.setAttribute('href', url.href)
  }

  get #stationInput() {
    return this.stationTarget.querySelector('input').value.trim()
  }

  get #isStationInputted() {
    return this.#stationInput !== ''
  }

  get #keywordInput() {
    return this.keywordTarget.querySelector('input').value.trim()
  }

  get #isKeywordInputted() {
    return this.#keywordInput !== ''
  }

  get #isLocalPage() {
    return this.hasPrefPathValue
  }
}
